import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-tracking';

import './FiltersExposedButton.scss';

const FiltersExposedButton = ({ text, onClick, dataTest, eventLabel }) => {
  const handleButtonClick = () => {
    Metrics.ga.sendEvent('Search', 'exposed-filters', eventLabel);
    onClick();
  };

  return (
    <div className={'filters-exposed-button'}>
      <Button
        onClick={handleButtonClick}
        fullWidth
        color="interaction"
        data-test={dataTest}
        size="large"
      >
        {text}
      </Button>
    </div>
  );
};

FiltersExposedButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  eventLabel: PropTypes.string.isRequired,
  dataTest: PropTypes.string
};

FiltersExposedButton.defaultProps = {
  dataTest: 'filters-exposed-button'
};

export default FiltersExposedButton;
